export const FOOTPRINT_CALCULATOR_BASE_ROUTE_ID = '66'
export const GERMAN_DATAPROTECTION_PAGE_ID = 15
export const ENGLISH_DATAPROTECTION_PAGE_ID = 18
export const GERMAN_CONTACT_PAGE_ID = 11
export const ENGLISH_CONTACT_PAGE_ID = 17
